import { render, staticRenderFns } from "./StudySetOverview.vue?vue&type=template&id=1d6b8c74&scoped=true&"
import script from "./StudySetOverview.vue?vue&type=script&lang=js&"
export * from "./StudySetOverview.vue?vue&type=script&lang=js&"
import style0 from "./StudySetOverview.vue?vue&type=style&index=0&id=1d6b8c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b8c74",
  null
  
)

export default component.exports